import { Select, SelectOption } from '@acast-tech/decibel';
import type { SelectProps } from '@acast-tech/decibel/dist/typings/components/Select/Select';

interface PrefixedSelectProps extends SelectProps {
  displayLabel?: string;
}

/**
 * Wraps Decibel's Select so the dropdown options show bare text while
 * the closed input displays a prefixed label (e.g. "Show: My Podcast").
 *
 * The native select text is made transparent and an absolutely-positioned
 * overlay renders the custom label on top.
 */
const PrefixedSelect = ({ displayLabel, style, children, ...selectProps }: PrefixedSelectProps) => (
  <div className="relative">
    <Select
      {...selectProps}
      style={{ fontSize: '14px', cursor: 'pointer', width: '100%', minWidth: 0, ...style, color: 'transparent' }}
    >
      {children}
    </Select>
    {displayLabel && (
      <span className="absolute z-[2] top-1/2 left-3 right-8 -translate-y-1/2 pointer-events-none text-sm truncate">
        {displayLabel}
      </span>
    )}
  </div>
);

export { PrefixedSelect, SelectOption };
